function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _styled from '@emotion/styled/base';
import { inputStructure } from '@tablecheck/tablekit-core';
import { InputAlert } from './InputAlert.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Wrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1bvynr91"
} : {
  target: "e1bvynr91",
  label: "Wrapper"
})(inputStructure.baseStyles, ";");
var LabelRow = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1bvynr90"
} : {
  target: "e1bvynr90",
  label: "LabelRow"
})(process.env.NODE_ENV === "production" ? {
  name: "1eoy87d",
  styles: "display:flex;justify-content:space-between"
} : {
  name: "1eoy87d",
  styles: "display:flex;justify-content:space-between",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
function InputStructure(_ref) {
  var input = _ref.input,
    name = _ref.name,
    label = _ref.label,
    description = _ref.description,
    alert = _ref.alert,
    labelAppend = _ref.labelAppend;
  return jsxs(Wrapper, {
    children: [label || labelAppend ? jsxs(LabelRow, {
      children: [jsx("label", {
        htmlFor: name,
        children: label
      }), jsx("small", {
        children: labelAppend
      })]
    }) : null, description ? jsx("aside", {
      children: description
    }) : null, input, alert ? jsx(InputAlert, _objectSpread({}, alert)) : null]
  });
}
export { InputStructure };
